@if (
  form
    ?.get('products')
    ?.at(0)
    ?.get('parameters')
    ?.get('protectLovedOnesInCaseOfAccidentOrDeathNeeds')?.value?.length ===
    0 && derrors
) {
  <info [option]="optionInfo1">
    Vous devez définir au moins un besoin pour continuer
  </info>
}
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-12">
                  <pr-input-radio
                    formControlName="protectLovedOnesInCaseOfAccidentOrDeath"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label="Protéger mes proches en cas d'accident ou de décès"
                  >
                  </pr-input-radio>
                </div>
              </div>
              @if (
                form
                  .get('products')
                  .at(0)
                  .get('parameters')
                  .get('protectLovedOnesInCaseOfAccidentOrDeath').value
              ) {
                <div class="row mt-1">
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted"
                      >Vos besoins
                    </span>
                  </div>
                  <div class="col-md-12">
                    <div class="checkbox">
                      <ng-template #default></ng-template>
                      <pr-checkbox-group
                        formControlName="protectLovedOnesInCaseOfAccidentOrDeathNeeds"
                        [template]="default"
                        [options]="options"
                      >
                      </pr-checkbox-group>
                    </div>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
